<template>
  <div class='loading'>
    <div class="loader">Loading...</div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss">
@import "../assets/css/base.scss";

</style>



// WEBPACK FOOTER //
// src/components/Loading.vue